export default __webpack_public_path__ + "static/media/sketch-international-tn.e42d40de.png";